import { render, staticRenderFns } from "./examine-popup.vue?vue&type=template&id=12847eec&scoped=true&"
import script from "./examine-popup.vue?vue&type=script&lang=js&"
export * from "./examine-popup.vue?vue&type=script&lang=js&"
import style0 from "./examine-popup.vue?vue&type=style&index=0&id=12847eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12847eec",
  null
  
)

export default component.exports